import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { formatRupiah } from "../lib/api";
import { formatDateTime } from "../lib/utils";

const number = (value) => Number(value || 0).toLocaleString("id-ID");

function noticePath(item) {
  if (item.role_view === "creator") return "/dashboard";
  if (item.role_view === "brand") return "/client";
  return "/admin/campaigns";
}

function mainAmount(item) {
  if (item.role_view === "creator") return formatRupiah(item.creator_earning);
  if (item.role_view === "brand") return formatRupiah(item.final_client_budget_used);
  return formatRupiah(item.final_platform_revenue);
}

function mainLabel(item) {
  if (item.role_view === "creator") return "Kamu dapat";
  if (item.role_view === "brand") return "Budget terpakai";
  return "Revenue admin";
}

export function CompletionNoticeCard({ item, compact = false, onSeen }) {
  return (
    <div className={`rounded-lg border-2 border-[#0A0A0A] bg-white ${compact ? "p-2.5" : "p-3"}`}>
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-1 text-xs font-black uppercase opacity-60">
            <CheckCircle2 size={13}/> Campaign selesai
          </div>
          <div className="font-display font-bold truncate mt-1">{item.title || "Campaign"}</div>
          <div className="text-xs text-[#4A4A4A] truncate">{item.brand_name || "-"} · {formatDateTime(item.completed_at)}</div>
        </div>
        <div className="text-right shrink-0">
          <div className="text-[10px] uppercase font-black opacity-60">{mainLabel(item)}</div>
          <div className="font-display font-black text-sm">{mainAmount(item)}</div>
        </div>
      </div>
      {!compact && (
        <div className="mt-3 grid grid-cols-2 sm:grid-cols-4 gap-2 text-xs">
          {item.role_view === "creator" ? (
            <>
              <Mini label="Views dibayar" value={number(item.creator_final_views)}/>
              <Mini label="Link approved" value={number(item.creator_approved_links)}/>
            </>
          ) : (
            <>
              <Mini label="Creator paid" value={formatRupiah(item.final_creator_payout)}/>
              <Mini label="Admin revenue" value={formatRupiah(item.final_platform_revenue)}/>
            </>
          )}
          <Mini label="Budget used" value={formatRupiah(item.final_client_budget_used)}/>
          <Mini label="Sisa budget" value={formatRupiah(item.final_client_budget_remaining)}/>
          <Mini label="Views final" value={number(item.final_approved_views)}/>
          <Mini label="Approved" value={number(item.final_approved_links)}/>
        </div>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <Link to={noticePath(item)} onClick={onSeen} className="nb-btn nb-btn-secondary text-xs px-3 py-2">
          Lihat Dashboard
        </Link>
        {onSeen && (
          <button type="button" onClick={onSeen} className="nb-btn text-xs px-3 py-2">
            Sudah Dilihat
          </button>
        )}
      </div>
    </div>
  );
}

export default function CampaignCompletionNoticePanel({ items, onSeen, title = "Campaign selesai", className = "" }) {
  if (!items?.length) return null;
  return (
    <section className={`nb-card-flat bg-[#D4FF00] p-3 sm:p-4 ${className}`} data-testid="campaign-completion-alert">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <span className="nb-pill bg-white">Final Campaign</span>
          <h2 className="font-display font-black text-lg sm:text-xl mt-2">{title}</h2>
          <p className="text-sm text-[#4A4A4A] mt-1">Payout dikunci sesuai tanggal dan jam selesai campaign. Views setelah itu tidak dibayarkan.</p>
        </div>
        <button type="button" onClick={() => onSeen?.(items)} className="nb-btn text-xs px-3 py-2">
          Tandai Semua Dilihat
        </button>
      </div>
      <div className="mt-3 grid lg:grid-cols-2 gap-3">
        {items.map((item) => (
          <CompletionNoticeCard key={item.notification_key || item.id} item={item} onSeen={() => onSeen?.([item])} />
        ))}
      </div>
    </section>
  );
}

function Mini({ label, value }) {
  return (
    <div className="rounded-md border-2 border-[#0A0A0A] bg-[#FDFBF7] p-2">
      <div className="text-[10px] uppercase font-black opacity-60">{label}</div>
      <div className="font-bold truncate">{value}</div>
    </div>
  );
}
